<template>
    <div>
        <product-header :actIndex="actIndex" :imgList="imgList" :topStyle="topStyle" :logo="logo"></product-header>
        <product-type :type="productType" @changeType="productCon"></product-type>
        <product-center :product="productCurrent" ></product-center> 
        <product-footer :bottom="bottom" :bottomInfo="contactInfo"></product-footer>
    </div>
</template>

<script>
import ProductHeader from '@/components/mobile/Header'
import ProductType from '@/components/mobile/ProductType'
import ProductCenter from '@/components/mobile/ProductCenter'
import ProductFooter from '@/components/mobile/Footer'
export default {
    name: 'Product',
    data () {
        return {
            actIndex: 2,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            contactInfo: {},
            productType: [],
            productList: {},
            productCurrent: [],
            productAll: [],
            productName: ''
        }
    },
    components: {
        ProductHeader,
        ProductType,
        ProductCenter,
        ProductFooter,
    },
    mounted () {
        // this.Pc_Mobile()
        this.getPageData()
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        // Pc_Mobile () {
        //     if(this._isMobile()) {
        //         this.$router.replace('/m_product');
        //     }else{
        //         this.$router.replace('/product');
        //     }
        // },
        getPageData () {
            this.$http.post('home/index/m_product',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background:url('"+this.$imgUrl+res.data.header[0].m_cpzx.replace(/\\/g,'/')+"')"
                this.contactInfo = res.data.contact[0]
                this.productType = res.data.type
                this.productAll = res.data.product
                this.$nextTick(()=>{
                    // this.$refs.jobRef.imgSwiper()
                })
            })
        },
        productCon (name) {
            this.productCurrent = this.productList[name];
            console.log(this.productCurrent)
        }
    },
    watch: {
        productType(newVal){
            this.productName = newVal[0].name
        },
        productAll(){
            var pages = {}
            this.productAll.forEach((item)=>{
                var type = item.type
                if(!pages[type]){
                    pages[type]=[]
                }
                pages[type].push(item)
            })
            this.productList = pages
            this.productCon(this.productType[0].name)
        }
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/Product.vue